export default __webpack_public_path__ + "static/media/43.4b0949c7.svg";